import * as React from "react";
import { Redirect } from "react-router-dom";
import { Session } from "../api";

export class Authenticated extends React.Component<{}, { redirectToLogin: boolean }> {

    constructor(props) {
        super(props);
        this.state = {
            redirectToLogin: false
        }
        Session.setUnauthorizedHandler((error) => {
            this.setState({
                redirectToLogin: true
            })
        })
    }

    public render() {
        const { redirectToLogin } = this.state
        if (redirectToLogin === true) {
            return <Redirect to='/login' />
        }
        return this.props.children;
    }
}


// WEBPACK FOOTER //
// ./src/components/Authenticated.tsx